import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { NgModule } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';

import { ASK_AI_COMPONENTS, ASK_AI_COMPONENTS_EXPORTS, ASK_AI_SERVICES } from './index';
import { SharedModule } from '@ispm/shared/shared.module';
import { UserModule } from '@ispm/user/user.module';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    InputTextModule,
    SharedModule,
    SidebarModule,
    UserModule,
  ],
  declarations: [...ASK_AI_COMPONENTS],
  exports: [...ASK_AI_COMPONENTS_EXPORTS],
  providers: [...ASK_AI_SERVICES]
})

export class AskAIModule { }
